import Styles from './RelationsSet.module.scss'
import { useState } from 'react';
import { useScrollLock } from 'components/hooks/useScrollLock';
import { useTranslation } from 'components/lib';

export default function RelationsSet({ setData, lines, setLines, toast, selectedOperation, ...props }) {
    const [startPoint, setStartPoint] = useState(null);
    const { lockScroll, unlockScroll } = useScrollLock();

    const relations = lines.map(entry => entry?.elements)

    const scrollToBottom = () => {
        window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth'
        });
    };

    const { t } = useTranslation()

    const handleOriginClick = (e) => {
        const element = e.target;
        if (startPoint === element) {
            startPoint.classList.remove(Styles.flashSelect);
            unlockScroll();
            setStartPoint(null);
        }
        else if (!startPoint) {
            lockScroll();
            setStartPoint(element);
            element.classList.add(Styles.flashSelect);
        }
    };

    const handleDestinationClick = (e) => {
        const element = e.target;
        if (startPoint) {
            if (!relations.includes(startPoint.textContent + '|' + element.textContent)) {
                connectElements(startPoint, element);
            } else {
                toast.dark(`Relation removed!`, {
                    type: 'info',
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                const existingRelationIndex = relations.findIndex(relation => {
                    return relation === startPoint.textContent + '|' + element.textContent;
                });
                const existingLines = [...lines];
                existingLines.splice(existingRelationIndex, 1);
                setLines(existingLines);

            }
            startPoint.classList.remove(Styles.flashSelect);
            setStartPoint(null);
            unlockScroll();
        } else {
            toast.dark(`Please select an origin element first!`, {
                type: 'info',
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    const connectElements = (start, end) => {
        const startRect = start.getBoundingClientRect();
        const endRect = end.getBoundingClientRect();
        const x1 = startRect.left + startRect.width + window.scrollX;
        const y1 = startRect.top + (startRect.height / 2) + window.scrollY;
        const x2 = endRect.left + window.scrollX;
        const y2 = endRect.top + (endRect.height / 2) + window.scrollY;
        const newLine = { x1, y1, x2, y2, elements: start.textContent + '|' + end.textContent };
        setLines([...lines, newLine]);
    };



    const resetRelations = () => {
        setLines([])
    };

    return (
        <>
            {
                (selectedOperation === 'cartesian' || selectedOperation === 'relation') && setData[0]?.length <= 5 && setData[1]?.length <= 5 ?
                    (
                        <>
                            <div id='relationsContainer' className={Styles.relationsContainer}>
                                <div id='setAContainer' className={Styles.setContainer}>
                                    {setData[0].map((element, index) => (
                                        <div
                                            id={`${element}-${index}`}
                                            onClick={(e) => { scrollToBottom(); handleOriginClick(e); }}
                                            className={`${Styles.elementDisplay} ${Styles.originElement}`}
                                            key={`${element}-${index}`}
                                            style={{
                                                cursor: startPoint && startPoint.id !== `${element}-${index}`
                                                    ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            {element}
                                        </div>
                                    ))}
                                </div>
                                <div id='setBContainer' className={Styles.setContainer}>
                                    {setData[1].map((element, index) => (
                                        <div
                                            id={`${element}-${index}`}
                                            onClick={handleDestinationClick}
                                            className={`${Styles.elementDisplay} ${Styles.destElement}`}
                                            key={element}
                                            style={{
                                                cursor: startPoint ? 'pointer' : 'not-allowed'
                                            }}
                                        >
                                            {element}
                                        </div>
                                    ))}
                                </div>
                                <svg id="lineCanvas" width="100%" height="100%" style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    pointerEvents: 'none'
                                }}>
                                    {lines.map((line, index) => (
                                        <line
                                            key={index}
                                            x1={line.x1}
                                            y1={line.y1}
                                            x2={line.x2}
                                            y2={line.y2}
                                            stroke="black"
                                            strokeWidth={2}
                                            strokeDasharray="5, 5"
                                            strokeLinecap="round"
                                            opacity={0.8}
                                        />
                                    ))}
                                </svg>
                            </div>
                            <button id='resetButton' onClick={resetRelations} className={`${Styles.resetButton} ${Styles.destElement}`}>
                                {t('Labs.Nodes.NodeSets.relations.button')}
                            </button>
                        </>
                    ) :
                    (
                        <div id='cartesianMessageContainer' style={{ fontWeight: 700 }}>
                            {
                                (setData[0]?.length <= 5 && setData[1]?.length <= 5)
                                    ? t('Labs.Nodes.NodeSets.relations.operation')
                                    : t('Labs.Nodes.NodeSets.relations.set')
                            }
                        </div>
                    )
            }
        </>
    )
}